import type { NestedFilterInput } from '@apeiron/common'
import { styled } from '@mui/material'
import {
  FilterSection,
  FilterSectionContent,
  FilterSectionHeader,
  FilterSectionTitle
} from '@src/components/share/filter/FilterSection'
import ResetFilter from '@src/components/share/filter/ResetFilter'
import * as R from 'ramda'
import { type ReactNode, useMemo } from 'react'

const Content = styled(FilterSectionContent)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0px;
`

const NestedFilterWrapper = <T extends NestedFilterInput>(props: Props<T>) => {
  const { className, title, filterInput, children, fields, handleOnReset } =
    props

  const numFilters = useMemo(() => {
    return R.sum(
      fields.map(field => {
        const values = filterInput[field]

        if (!Array.isArray(values)) {
          return 0
        }

        return values.length
      })
    )
  }, [fields, filterInput])

  return (
    <FilterSection className={className} defaultExpanded>
      <FilterSectionHeader>
        <FilterSectionTitle>{title}</FilterSectionTitle>
        <ResetFilter filterCount={numFilters} onReset={handleOnReset} />
      </FilterSectionHeader>
      <Content>{children}</Content>
    </FilterSection>
  )
}

type Props<T> = {
  className?: string
  fields: (keyof T)[]
  filterInput: T
  title: string
  children: ReactNode
  handleOnReset: () => void
}

export default NestedFilterWrapper
